import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";
import AOS from "aos";
import "aos/dist/aos.css";
import MultiplexAds from "../../Admin/Pages/MultiplexAds";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
export default function ProductDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const location = useLocation();
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);
  useEffect(() => {
    if (product) {
      setTimeout(() => {
        AOS.refreshHard();
      }, 100);
    }
  }, [product]);
  useEffect(() => {
    const fetchMachine = async () => {
      try {
        const res = await fetch(API.LIST_MACHINES);
        const json = await res.json();

        const machines = json.data || json;

        const selected = machines.find(
          (item) => String(item.id) === String(id),
        );

        setProduct(selected || null);
      } catch (err) {
        console.log(err);
      }
    };

    fetchMachine();
  }, [id]);
  const [seller, setSeller] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = product?.image ? product.image.split(",") : [];
  const [wishlist, setWishlist] = useState([]);
  const [user, setUser] = useState(null);
  /* =========================
  FETCH SELLER (UPDATED)
  ========================= */
  useEffect(() => {
    if (product?.user_id) {
      fetchSeller();
    }
  }, [product]);

  // Add this inside your ProductDetails component
  useEffect(() => {
    const syncWishlist = () => {
      const loginUser = JSON.parse(sessionStorage.getItem("user"));
      if (loginUser) {
        const saved =
          JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];
        setWishlist(saved);
      }
    };

    // Listen for the event we created
    window.addEventListener("cartUpdated", syncWishlist);
    window.addEventListener("storage", syncWishlist);

    return () => {
      window.removeEventListener("cartUpdated", syncWishlist);
      window.removeEventListener("storage", syncWishlist);
    };
  }, []);

  const fetchSeller = async () => {
    try {
      // Points to the unified api.php
      // Note: You'll need to add a 'get_user' case in your api.php
      // if you want to fetch extra details about the seller/user
      const res = await fetch(`${API.GET_USER}&id=${product.user_id}`);

      const data = await res.json();
      setSeller(data);
    } catch (error) {
      console.log("Seller Fetch Error", error);
    }
  };
  useEffect(() => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));
    setUser(loginUser);

    if (loginUser) {
      const savedWishlist =
        JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];
      setWishlist(savedWishlist);
    }
  }, []);
  useEffect(() => {
    if (!product) return;

    if (location.state?.activeTab === "seller") {
      setTimeout(() => {
        const sellerTab = document.querySelector('[data-bs-target="#seller"]');

        if (sellerTab) {
          sellerTab.click();
        }
      }, 100);
    }
  }, [product, location]);
  if (!product) {
    return (
      <div className="container text-center mt-5">
        <h4>Product not found</h4>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/machine")}
        >
          Back to Shop
        </button>
      </div>
    );
  }
  const toggleLike = () => {
    if (!user) {
      alert("Please login first");
      return;
    }

    let updatedWishlist = [...wishlist];
    const exists = updatedWishlist.find((item) => item.id === product.id);

    if (exists) {
      updatedWishlist = updatedWishlist.filter(
        (item) => item.id !== product.id,
      );
    } else {
      // Standardize the machine object for the wishlist
      updatedWishlist.push({ ...product, type: "machine" });
    }

    setWishlist(updatedWishlist);
    localStorage.setItem(
      `wishlist_${user.id}`,
      JSON.stringify(updatedWishlist),
    );

    // 🔥 ADD THIS: Shout to the Navbar to update its count
    window.dispatchEvent(new Event("cartUpdated"));
  };

  return (
    <div className="container-fluid product-page">
      <div className="row">
        {/* ================= LEFT CONTENT ================= */}
        <div className="col-lg-12">
          {/* BACK BUTTON */}
          <div className="mb-3" data-aos="fade-right">
            <button
              className="btn btn-light back-btn"
              onClick={() => navigate(-1)}
            >
              <i className="bi bi-arrow-left"></i> Back
            </button>
          </div>
          <div className="row">
            <div className="col-md-6" data-aos="fade-right">
              {" "}
              <div className="product-image-section">
                <img
                  data-aos="zoom-in"
                  data-aos-duration="900"
                  src={`${UPLOADS.MACHINE_IMAGE}${product.user_id}/${images[currentIndex]}?t=${Date.now()}`}
                  className="product-main-img"
                  alt={product.machine_name}
                />

                {/* THUMBNAILS */}
                <div className="thumbnail-wrapper">
                  {images.map((img, index) => (
                    <img
                      key={index}
                      src={`${UPLOADS.MACHINE_IMAGE}${product.user_id}/${img}?t=${Date.now()}`}
                      onClick={() => setCurrentIndex(index)}
                      className={`thumbnail-img ${currentIndex === index ? "active-thumb" : ""}`}
                      alt="thumbnail"
                    />
                  ))}
                </div>
              </div>
              {/* PRODUCT INFO */}
              <div className="product-card1 mt-4" data-aos="fade-up">
                <div className="d-flex justify-content-between">
                  <div>
                    <h2 className="product-title">{product.machine_name}</h2>
                    <h3 className="product-price">
                      ₹ {Number(product.price).toLocaleString("en-IN")}
                    </h3>
                  </div>
                  <button
                    className="like-btn"
                    onClick={toggleLike}
                    data-aos="zoom-in"
                    data-aos-delay="300"
                  >
                    <i
                      className={
                        wishlist.some((w) => w.id === product.id)
                          ? "bi bi-heart-fill text-danger"
                          : "bi bi-heart"
                      }
                    ></i>
                  </button>
                </div>
                <p className="product-desc">{product.description}</p>
              </div>
            </div>
            <div className="col-md-6" data-aos="fade-left">
              {" "}
              <div className="mt-4">
                <ul
                  className="nav nav-tabs custom-tabs mb-2"
                  data-aos="fade-down"
                >
                  <li className="nav-item">
                    <button
                      className="nav-link active"
                      data-bs-toggle="tab"
                      data-bs-target="#info"
                    >
                      Machine Info
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className="nav-link"
                      data-bs-toggle="tab"
                      data-bs-target="#seller"
                    >
                      Seller Info
                    </button>
                  </li>
                </ul>

                <div className="tab-content">
                  {/* MACHINE INFO */}
                  <div className="tab-pane fade show active tab-box" id="info">
                    <table className="info-table">
                      <tbody>
                        <tr data-aos="fade-up">
                          <th>Machine Type</th>
                          <td>{product.machine_name}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>Left Side Head Type</th>
                          <td>{product.left_head_type}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>Right Side Head Type</th>
                          <td>{product.right_head_type}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>Machine Age</th>
                          <td>{product.machine_old}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Brand</th>
                          <td>{product.brand}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>Model</th>
                          <td>{product.model}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>Area</th>
                          <td>{product.Area}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th> No Of Heads</th>
                          <td>{product.NoOfHeads}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>No Of Needles</th>
                          <td>{product.NoOfNeedls}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>Max Sewing Speed</th>
                          <td>{product.Maxsewingspeed} RPM</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>Beam Body Size(MM)</th>
                          <td>{product.beamBody}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>Computer Type</th>
                          <td>{product.Comtype}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>Motor</th>
                          <td>{product.motor}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>USB Port</th>
                          <td>{product.usbport}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>Details</th>
                          <td>{product.description}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>Address</th>
                          <td>{product.location}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>City</th>
                          <td>{product.city}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>State</th>
                          <td>{product.state}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="tab-pane fade show  tab-box" id="seller">
                    <table className="info-table">
                      <tbody>
                        <tr data-aos="fade-up">
                          <th>Name</th>
                          <td>{product.name}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>Mobile No</th>
                          <td>{product.phone}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>Address</th>
                          <td>{product.location}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>City</th>
                          <td>{product.city}</td>
                        </tr>
                        <tr data-aos="fade-up">
                          <th>State</th>
                          <td>{product.state}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* IMAGE SECTION */}

          {/* ================= TABS ================= */}
        </div>
        <HorizontalAds />
        {/* ================= RIGHT ADS ================= */}
        {/* <div className="col-lg-3">
          <div className="ads-sidebar p-3 bg-white shadow-sm rounded text-center">
            <h5 className="ads-title">Sponsored</h5>

            <div className="ad-card mt-3">
              <div className="ad-placeholder">
                <p className="small text-muted">Your Ad Here</p>
              </div>

              <p className="small mt-2">Premium Threads Sale!</p>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}
